// extracted by mini-css-extract-plugin
module.exports = {"loading_box":"FJLoading_loading_box__2HJcm","loading_full":"FJLoading_loading_full__CAkT8","img":"FJLoading_img__1dzDh","rotate":"FJLoading_rotate__3Yb_l"};